// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Bridge from "./api/bridge.js" //此路径根据实际bridge.js路径填写
Vue.prototype.$bridge = Bridge
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// import Bridge from './api/dsbridge.js'
// Vue.prototype.$bridge = Bridge

Vue.config.productionTip = false
Vue.filter('defaultImage', function (value) {
  var defaultImage = "https://image.demo.b2b2c.shopxx.net/6.0/default_thumbnail_product_image.png";
  if (!value) {
    return defaultImage
  } else {
    return value
  }
})
Vue.filter('defaultName', function (value) {
  if (!value) {
    return " "
  } else {
    return value
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js